var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['price-pair', `price-pair--${_vm.layout}`]},[(_vm.showInternalAmount)?_c('InternalAmount',{staticClass:"price-pair__internal",attrs:{"amount":_vm.internalAmountValue}}):_vm._e(),(_vm.showFiatAmount)?_c('span',{staticClass:"price-pair__fiat"},[_vm._v(_vm._s(_vm.formattedFiat))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }